import { render, staticRenderFns } from "./MT.vue?vue&type=template&id=88086458&scoped=true"
import script from "./MT.vue?vue&type=script&lang=js"
export * from "./MT.vue?vue&type=script&lang=js"
import style0 from "./MT.vue?vue&type=style&index=0&id=88086458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88086458",
  null
  
)

export default component.exports